<template>
  <div class="my-4">
    <!-- <template> -->
        <div class="mt-4 mx-4 d-flex">
            <!-- <v-combobox
                v-model="selectedTags"
                :items="formattedTags"
                item-text="label"
                item-value="id"
                label="Select Tags to Assign"
                multiple
                chips
                clearable
                small-chips
                prepend-inner-icon="tags"
                deletable-chips
            >
            </v-combobox> -->
            <div style=" border: 1px solid rgba(0, 0, 0, 0.7);" class="pl-2">
                <v-autocomplete
                    placeholder="Assign tags to artworks"
                    v-model="selectedTags"
                    :items="formattedTags"  
                    multiple
                    chips
                    clearable
                    flat
                    item-text="label"
                    item-value="id"
                    hide-details
                    single-line 
                    
                    full-width
                    hide-selected
                    prepend-inner-icon="tags"
                    color
                >
                    <template v-slot:item="data">
                        <!-- <v-list two-line> -->
                        <!-- :class="{ 'red--text': data.item.concept_tag == 1 }" -->
                        <v-list-tile-content>
                        <v-list-tile-title><span class="mr-2 px-0" v-if="data.item.concept_tag == 1">&starf;</span>{{
                            data.item.name
                        }}</v-list-tile-title>
                        <v-list-tile-sub-title v-if="data.item.concept_tag != 1" class="text-xs-right grey--text"
                            v-html="data.item.category ? data.item.category : ''"></v-list-tile-sub-title>
                        <v-divider></v-divider>
                        </v-list-tile-content>
                        <!-- <v-flex class="text-xs-left">
                            {{}}
                            </v-flex>
                            <v-flex class="text-xs-right">
                            {{`${}`}}
                            </v-flex> -->
                        <!-- </v-list> -->
                    </template>
                    <template v-slot:selection="data">
                        <v-chip
                            :selected="data.selected"
                            small
                            color="primary"
                            text-color="white"
                            dense
                            close
                            class="chip--select-multi"
                            @input="remove(data.item)"
                        >
                            # {{ data.item.label }}
                        </v-chip>
                    </template>
                </v-autocomplete>
            </div>

            <!-- add checkbox 'replace' to delete any existing tags and replace them with the selected tags -->
            <!-- <v-checkbox label="Replace" v-model="replace" class="ml-4" color="black"></v-checkbox> -->
        </div>
        <v-btn color="green" small @click="assignTagsToMultipleArtworks" class="ml-4 white--text">Assign Tags</v-btn>
        <v-btn color="black" small @click="closeDialog()" class="ml-4 white--text">Close</v-btn>
    <!-- </template> -->
  </div>
</template>

<script>
import axios from '@/utils/apiClient'
import Vue from 'vue'
import {serverBus} from '../../main'

export default {
    data() {
        return {
            selectedTags: [],
            tags: [],
            replace: false
        };
    },
    computed: {
        formattedTags() {
            console.log(this.$store.getters.conceptual_tags.length);
            console.log(this.$store.getters.cataloguing_tags.length);
            var con_tags = this.$store.getters.conceptual_tags.sort((a, b) => a.subcategory.localeCompare(b.subcategory))
                .map((tag) => ({
                    label: `${tag.subcategory} #${tag.name}`,
                    name: tag.name,
                    id: tag.id,
                }));
            var cat_tags = this.$store.getters.cataloguing_tags.sort((a, b) => a.subcategory.localeCompare(b.subcategory))
                .map((tag) => ({
                    label: `${tag.subcategory} #${tag.name}`,
                    name: tag.name,
                    id: tag.id,
                }));
            return con_tags.concat(cat_tags).sort((a, b) => a.name.localeCompare(b.name));
        },
    },
    mounted() {
        this.tags = this.$store.getters.conceptual_tags
    },
    methods: {
        remove(item) {
            // find index of item in selectedTags by id of item
            const index = this.selectedTags.indexOf(item.id)
            if (index >= 0) this.selectedTags.splice(index, 1)
        },
        assignTagsToMultipleArtworks(tagIds) {
            this.$emit('showSnackbar', 'Assigning tags to selected artworks...')
            axios
                .post(`${this.$globals.apiserver}/artworks/assign_tags`, {
                    artwork_ids: this.$store.state.currentSelection, // Array of selected artwork IDs
                    tag_ids: this.selectedTags             // array of tag IDs to assign
                })
                .then(response => {
                    serverBus.$emit('showSnackbar', 'Tags assigned to selected artworks.', 'green')
                    this.$store.dispatch('loadArtworks')
                    this.$emit('switchOffDialog')
                    this.errors = {}
                    this.selectedTags = []
                })
                .catch(error => {
                    this.errors = error.response.data
                    serverBus.$emit('showSnackbar', 'Error saving tags to artworks.', 'red')
                })
        },
        closeDialog() {
            this.$emit('switchOffDialog')
        },
        // assignTags() { 
        //     // load whole tag objects from store from tag ids in this.selectedTags
        //     var selectedTagsObjects = [];
        //     for (var i = 0; i < this.selectedTags.length; i++) {
        //         selectedTagsObjects [i] = this.formattedTags.find(tag => tag.id === this.selectedTags[i])
        //     }

        //     this.$store.dispatch('assignMultipleTagsToCurrentSelection', selectedTagsObjects );

        //     const payload = {
        //         selectedArtworks: this.$store.state.currentSelection, // Array of selected artwork IDs
        //         selectedTags: this.selectedTags,            // Array of selected tag IDs
        //         replace: this.replace                       // Boolean indicating whether to replace or add tags
        //     };

        //     axios.post(`${Vue.prototype.$globals.apiserver}/artworks/update_tags`, payload)
        //         .then(response => {
        //             // Handle success
        //             console.log('Tags updated successfully', response);
        //         })
        //         .catch(error => {
        //             // Handle error
        //             console.error('Error updating tags', error);
        //         });
        // },

        // function updateArtworkTags(artworkId, tagIds) {
        //     const url = `${Vue.prototype.$globals.apiserver}/artworks/${artworkId}/update_tags`

        //     // Prepare the data to be sent in the request
        //     const data = {
        //         tag_ids: tagIds
        //     };

        //     // Make the API call
        //     axios.put(url, data)
        //         then(response => {
        //         // Handle success
        //         console.log('Tags updated successfully', response.data);
        //         // Optionally, update the Vuex store or local component state
        //         })
        //         .catch(error => {
        //         // Handle error
        //         console.error('Error updating tags', error);
        //     });
        


            // this.$store.dispatch('addTagsToCurrentSelection', this.selectedTags);
            // iterate over selected tags and assign to current selection
            // console.log(this.selectedTags);
            // console.log(this.selectedTags);
            // this.selectedTags.forEach((tag) => {
            //     this.add_tag_to_current_selection(tag);
            // });
        
        // add_tag_to_current_selection(tag) {
        //     this.$store.dispatch('addTagToCurrentSelection', tag);
        // },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/artworks/AttachTagToArtworksDialog.vue